import { toJS } from "mobx";

const dotNotate=function(obj,target={},prefix="") {
  if(typeof obj === "object" && obj!==null) {
    Object.keys(obj).forEach((key) => {
      if (typeof (obj[key]) === "object") {
        dotNotate(obj[key], target, prefix + key + ".");
      } else {
        return target[prefix + key] = obj[key];
      }
    });
  }

  return target;
}

export default function setPlaceholders(rootStore, row, url) {
  if (url.indexOf('{{') > -1) {
    const ob = {
      order: toJS(rootStore.memoryStore.memory.order),
      page: toJS(rootStore.memoryStore.memory.page),
      filter: rootStore.searchStore.getFilter(),
      row: row
    }
    const dotted = dotNotate(ob);
    const matches = url.match(/{{[0-9\_a-z\.]+}}/gi);
    console.log('dotted', dotted, matches);
    for (let i in matches) {
      const index = matches[i].replace('{{', '').replace('}}', '');
      const replacer = dotted[index] || "";
      url = url.replace(matches[i], replacer);
    }

  }
  return url;
}